export const singlePatientId1 = {
  id: 'patient_id1',
  wellnessVision: 'My vision',
  enrollmentDate: '2020-04-21T14:59:27.233Z',
  lastContact: '2021-03-18T03:42:53.544Z',
  hasMedicalData: true,
  createdAt: '2020-04-21T14:59:27.233Z',
  updatedAt: '2021-03-18T07:42:53.545Z',
  userId: 1,
  createdBy: null,
  updatedBy: 1,
  patientAvailabilityId: null,
  programId: 1,
  patientGoalId: null,
  isEhrUser: true,
  user: {
    id: 1,
    email: 'test.test@patient.com',
    isVerified: true,
    isVerificationExpired: true,
    timezone: 'Asia/Yerevan',
    isSubscribed: true,
    authType: null,
    authEnabled: false,
    allowedFeatures: null,
    isActive: true,
    user_detail: {
      fullName: 'Test Name Test LastName',
      firstName: 'Test Name',
      lastName: 'Test LastName',
      birthDate: '1970-10-19',
      gender: 1,
      addressLine1: null,
      addressLine2: null,
      city: null,
      mobilePhone: '+16505130514',
      homePhone: null,
      countryId: null,
      stateId: null,
      zipCodeId: 15095,
      accountInfoStatus: 3,
      shippingAddress1: null,
      shippingAddress2: null,
      shippingCity: null,
      shippingZipId: 80001,
      shippingStateId: 'Colorado',
    },
  },
  program: {
    id: 1,
    name: 'Core 12 Month Program',
    duration: 12,
  },
  organizations_patients: [
    {
      organizationId: 8,
      organization: {
        id: 8,
        name: 'Test Medical Center',
      },
    },
  ],
  patient_groups: [],
  providers_patients: [
    {
      id: 234,
      provider: {
        id: 6,
        active: true,
        providers_users: [
          {
            id: 4,
            user: {
              id: 5,
              user_detail: {
                firstName: 'Provider Name',
                lastName: 'Provider LastName',
              },
            },
          },
        ],
      },
    },
  ],
};

export const singlePatient = {
  id: 1,
  wellnessVision: 'My vision',
  enrollmentDate: '2020-04-21T14:59:27.233Z',
  lastContact: '2021-03-18T03:42:53.544Z',
  hasMedicalData: true,
  createdAt: '2020-04-21T14:59:27.233Z',
  updatedAt: '2021-03-18T07:42:53.545Z',
  userId: 1,
  createdBy: null,
  updatedBy: 1,
  patientAvailabilityId: null,
  programId: 1,
  patientGoalId: null,
  isEhrUser: true,
  user: {
    id: 1,
    email: 'test.test@patient.com',
    isVerified: true,
    isVerificationExpired: true,
    timezone: 'Asia/Yerevan',
    isSubscribed: true,
    authType: null,
    authEnabled: false,
    allowedFeatures: null,
    isActive: true,
    user_detail: {
      fullName: 'Test Name Test LastName',
      firstName: 'Test Name',
      lastName: 'Test LastName',
      birthDate: '1970-10-19',
      gender: 1,
      addressLine1: null,
      addressLine2: null,
      city: null,
      mobilePhone: '+16505130514',
      homePhone: null,
      countryId: null,
      stateId: null,
      zipCodeId: 15095,
      accountInfoStatus: 3,
      shippingAddress1: null,
      shippingAddress2: null,
      shippingCity: null,
      shippingZipId: 80001,
      shippingStateId: 'Colorado',
    },
  },
  program: {
    id: 1,
    name: 'Core 12 Month Program',
    duration: 12,
  },
  organizations_patients: [
    {
      organizationId: 8,
      organization: {
        id: 8,
        name: 'Test Medical Center',
      },
    },
  ],
  patient_groups: [],
  providers_patients: [
    {
      id: 234,
      provider: {
        id: 6,
        active: true,
        providers_users: [
          {
            id: 4,
            user: {
              id: 5,
              user_detail: {
                firstName: 'Provider Name',
                lastName: 'Provider LastName',
              },
            },
          },
        ],
      },
    },
  ],
};

export const patientsOfProvider = {
  count: 1,
  rows: [
    {
      id: 1,
      userId: 307,
      email: 'test@patient.com',
      firstName: 'Test1',
      lastName: 'P1.',
      birthDate: '1990-08-29',
      phoneNumber: '1111111111',
      organizationId: 40,
      active: true,
    },
    {
      id: 2,
      userId: 317,
      email: 'test@patient2.com',
      firstName: 'Test2',
      lastName: 'P2.',
      birthDate: '1992-08-29',
      phoneNumber: '1135432111',
      organizationId: 40,
      active: true,
    },
  ],
};
